module.exports = __webpack_public_path__ + "img/logoIn.8c75ef78.svg";